const EN = {
    title: 'Change your',
    title2: 'password',
    description: 'Pick a new password to continue.',
    helperText: 'Keep in mind that it cannot be personal data or consecutive numbers.',
    inputs: {
        password: {
            label: 'Enter your new password: ',
            placeholder: 'Enter your new password'
        },
        confirmPassword: {
            label: 'Confirm password: ',
            placeholder: 'Rewrite your new password'
        },
    },
    help: {
        title: 'The password must have at least: ',
        list: {
            0: '8 characters',
            1: 'A lower case character',
            2: 'An upper case character',
            3: 'A number',
            4: 'A special character'
        }
    },
    changePassword: {
        success: 'Your password has been created successfully.',
        error: 'The passwords do not match.'
    },
    recover: {
        success: 'The user has been validated correctly.',
        description: 'Please enter your new password.'
    },
    // Onboarding flow
    titleCreate: 'Choose your',
    titleCreate2: 'password',
    inputsCreate: {
        password: {
            placeholder: 'Generate your password'
        },
        confirmPassword: {
            placeholder: 'Rewrite your password'
        }
    }
};

export default EN;
